import React from 'react';

import Shimmer from 'components/Shimmer';

import { Container, Filter, Checkbox, Circle } from './styles';

const LoaderDesktop = () => (
  <Container>
    <Filter className="box">
      <Filter.Title>
        <Shimmer>Ordenar</Shimmer>
      </Filter.Title>
      <ul>
        <li>
          <Circle />
          <Shimmer>Recomendado</Shimmer>
        </li>
        <li>
          <Circle />
          <Shimmer>Precio (menor primero)</Shimmer>
        </li>
        <li>
          <Circle />
          <Shimmer>Estrellas (mayor primero)</Shimmer>
        </li>
      </ul>
    </Filter>
    <Filter>
      <Filter.Title>
        <Shimmer>Price per day</Shimmer>
      </Filter.Title>
      <Filter.Content>
        <Shimmer width="242px" height="48px" />
      </Filter.Content>
    </Filter>
    <Filter>
      <Filter.Title>
        <Shimmer>Categorias</Shimmer>
      </Filter.Title>
      <ul>
        <li>
          <Checkbox />
          <Shimmer>SUV Grande</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>SUV Standard</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>Intermedio</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>Premium</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>Economico</Shimmer>
        </li>
      </ul>
    </Filter>
    <Filter>
      <Filter.Title>
        <Shimmer>Transmission</Shimmer>
      </Filter.Title>
      <ul>
        <li>
          <Checkbox />
          <Shimmer>Automatic</Shimmer>
        </li>
      </ul>
    </Filter>
    <Filter>
      <Filter.Title>
        <Shimmer>Compania</Shimmer>
      </Filter.Title>
      <ul>
        <li>
          <Checkbox />
          <Shimmer>localiza</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>Hertz</Shimmer>
        </li>
      </ul>
    </Filter>
    <Filter>
      <Filter.Title>
        <Shimmer>No. de pasajeros</Shimmer>
      </Filter.Title>
      <ul>
        <li>
          <Checkbox />
          <Shimmer>5</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>6</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>7</Shimmer>
        </li>
        <li>
          <Checkbox />
          <Shimmer>8</Shimmer>
        </li>
      </ul>
    </Filter>
    <Filter>
      <Filter.Title>
        <Shimmer>Precio</Shimmer>
      </Filter.Title>
      <Filter.Content>
        <Shimmer width="242px" height="48px" />
      </Filter.Content>
    </Filter>
  </Container>
);

export default LoaderDesktop;
